import shopifyWarehouseDefaults from '../shopify-warehouse-generic/config.js';

export default {
  includes: ['shopify-warehouse-generic'],
  ...shopifyWarehouseDefaults,
};
